const FLAGS = {
  pt: "🇵🇹",
  en: "🇬🇧",
  es: "🇪🇸",
  fr: "🇫🇷",
  de: "🇩🇪",
  it: "🇮🇹",
  nl: "🇳🇱",
  pl: "🇵🇱",
  ru: "🇷🇺",
  ko: "🇰🇷",
};

export function languageFlag(langCode) {
  if (!langCode) return "🌐";
  const key = String(langCode).slice(0, 2).toLowerCase();
  return FLAGS[key] || "🌐";
}

const LABELS = {
  pt: "Português",
  en: "Inglês",
  es: "Espanhol",
  fr: "Francês",
  de: "Alemão",
  it: "Italiano",
  nl: "Neerlandês",
  pl: "Polaco",
  ru: "Russo",
  ko: "Coreano",
};

export function languageLabel(langCode) {
  if (!langCode) return "Outro";
  const key = String(langCode).slice(0, 2).toLowerCase();
  if (LABELS[key]) return LABELS[key];
  // Sem idioma detetado (fallback de dashboardMetrics) → só "Outro".
  // Código desconhecido mas presente → mostra o código para o distinguir.
  if (key === "ou") return "Outro";
  return `Outro (${key})`;
}
